'use strict'
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ButtonComponent } from '../../../src/components/commonComponents/UIComponent';
import MergeDropdownComponent from '../commonComponents/MergeDropdownComponent';
import TagsComponent from '../commonComponents/TagsComponent';
import './css/style.css';
// import ErrorComponent from '../commonComponents/ErrorComponent';
// import ReactDOM from 'react-dom'
// import LoadingComponent from '../commonComponents/LoadingComponent';
// import CallAPI from '../commonComponents/AxiosHelper';

class StepFour extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                "transaction":[],
                "master":[]
            },
            joinData:[],
        }

        // this.getTableColumns = this.getTableColumns.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.submitTables = this.submitTables.bind(this);
        this.getSelectedTableKeys = this.getSelectedTableKeys.bind(this);
        this.getStateFromChild = this.getStateFromChild.bind(this);
        this.getColumnsToConsider = this.getColumnsToConsider.bind(this);
        this.prepareMergeArray = this.prepareMergeArray.bind(this);
        this.nextAction = this.nextAction.bind(this);
        this.backAction = this.backAction.bind(this);
    }

    componentWillMount() {
        this.getStateFromChild()
    }

    getFilteredTableColumns(tableArray){
        let final_table_columns = [];
        let tableColumns = this.props.stepData.fetchIncludedColumns(tableArray)

        if(tableColumns.length > 1){
            tableColumns.forEach(element => {
                final_table_columns = [...final_table_columns,...element['columnConfig']];
            });
        } else {
            final_table_columns = tableColumns[0]['columnConfig'];
        }
        return final_table_columns;
    }

    handleTableChange(e, reference) {
        let data = this.state.data;
        if (e.target.title === "Select transaction columns" || e.target.title !== "Select transaction tables") {
            let filteredTable = reference.props.dropdownConfig.dropdownData.filter((element, i) => {
                return e.target.value === element.value && e.target.options[e.target.options.selectedIndex].attributes[0].value === element.subtext_value;
            });
            let existingEntryIndex = data[reference.props.type].findIndex(el => el.tableValue === filteredTable[0].tableValue);
            existingEntryIndex > -1 ? data[reference.props.type].splice(existingEntryIndex, 1) : null;
            data[reference.props.type].push(filteredTable[0]);
        }
        e.target.title !== "Select transaction tables" ? this.setState({data: data}): null;
    }

    submitTables() {
        let tempVariable = false;
        if (this.props.stepData.state.selectedTable.master.length === 0 && this.props.stepData.state.selectedTable.transaction.length > 0) {
            if (this.props.stepData.state.selectedTable.transaction.length === this.state.data.transaction.length) {
                tempVariable = true;
            } else {
                tempVariable = false;
                alert("Select column from all the availabe tables for Key");
            }
        } else if (this.props.stepData.state.selectedTable.master.length > 0 && this.props.stepData.state.selectedTable.transaction.length > 0) {
            if (this.state.data.master.length === 1 && this.state.data.transaction.length === 1) {
                tempVariable = true;
            } else {
                tempVariable = false;
                alert("Select column from all the availabe tables for Key");
            }
        }
        if (tempVariable) {
            jQuery('.selectpicker').selectpicker('val', '');
            let joinData = this.props.stepData.state.joinData;
            let joinArray = {};
            // joinArray['id'] = this.state.joinData.length;
            if (this.state.data['master'].length > 0 && this.state.data['transaction'].length > 0) {
                joinArray['id'] = `${this.state.data['transaction'][0]['tag_name']}_${this.state.data['master'][0]['tag_name']}}`;
                joinArray['text'] = (<>
                    <span>{`${this.state.data['transaction'][0]['value']}`}</span>
                    <sub className="ml-1">{`${this.state.data['transaction'][0]['subtext_value']}`}</sub>
                    <span className="tx-medium mx-2">join</span>
                    <span>{`${this.state.data['master'][0]['value']}`}</span>
                    <sub className="ml-1">{`${this.state.data['master'][0]['subtext_value']}`}</sub>
                </>);
                let objectToSet = this.state.data['transaction'].length !== 0 ? JSON.parse(JSON.stringify(this.state.data['transaction'][0])) : null;
                joinArray['transaction'] = objectToSet;
            } else if (this.state.data['master'].length === 0 && this.state.data['transaction'].length > 0) {
                let finalArrayToCreateId = []
                let tagToDisplay = []
                this.state.data['transaction'].map((singleElement, index) => {
                    finalArrayToCreateId.push(singleElement['tag_name']);
                    if (this.state.data['transaction'].length - 1 === index) {
                        tagToDisplay.push(<><span>{singleElement['value']}</span><sub className="ml-1">{singleElement['subtext_value']}</sub></>);
                    } else {
                        tagToDisplay.push(<><span>{singleElement['value']}</span><sub className="ml-1">{singleElement['subtext_value']}</sub><span className="tx-medium mx-2">join</span></>);
                    }
                })
                joinArray['id'] = finalArrayToCreateId.join('_');
                joinArray['text'] = (<>{tagToDisplay}</>)
                let arrayToSet = this.state.data['transaction'].length !== 0 ? [...this.state.data['transaction']] : null;
                joinArray['transaction'] = arrayToSet;
            }
            // joinArray['text'] = `${this.state.data['transaction'][0]['tag_name']} join ${this.state.data['master'][0]['tag_name']}`;
            // joinArray['text'] = (<><span>{`${this.state.data['transaction'][0]['tag_name']}`}</span> <i className="feather" 
            //     data-feather="plus" aria-hidden="true"></i> <span>{`${this.state.data['master'][0]['tag_name']}`}</span></>);
            // joinArray['text'] = `${this.state.data['transaction'][0]['tag_name']} join ${this.state.data['master'][0]['tag_name']}`;
            // joinArray['text'] = (<>{`${this.state.data['transaction'][0]['tag_name']}`}<span className="tx-medium mx-2">join</span> {`${this.state.data['master'][0]['tag_name']}`}</>);
            let masterArrToSet = this.state.data['master'].length !== 0 ? JSON.parse(JSON.stringify(this.state.data['master'][0])) : null;
            joinArray['master'] = masterArrToSet;

            let check = this.props.stepData.state.joinData.filter((element, i) => {
                return joinArray['id'] == element['id'];
            });

            if (check.length == 0) {
                joinData.push(joinArray);
                this.setState({
                    data: {
                        "transaction": [],
                        "master": []
                    },
                    joinData: joinData,
                });
            }
        // let result = this.prepareMergeArray(joinArray);
        }
    }

    getStateFromChild(data = [], reference) {
        if (data !== null && data !== undefined) {
         this.setState({
            joinData:data
         })
         this.props.stepData.state.joinData = data;
        }
    }

    getColumnsToConsider(tableName, index){
        let columns_to_consider = {};
        let tableToFilter, columns_array = null;
        if (this.state.joinData[index].master === null && Object.values(this.state.joinData[index].transaction).length > 0) {
            tableToFilter = this.props.stepData.state.selectedTable.transaction;
        } else {
            tableToFilter = this.props.stepData.state.selectedTable.master;
        }
        var master_table_data = tableToFilter.filter((element,i)=>{
            return tableName == element.value;
        });
        columns_array = master_table_data[0]['columnConfig'];
        columns_array.forEach(element => {
            columns_to_consider[element.value] = element.value;
        });        
        return columns_to_consider;
    }

    getSelectedTableKeys(configArray, tableName) {
        var innerArray = null
        if (configArray.master === null) {
            innerArray = {}
            configArray['transaction'].forEach( el => {
                innerArray[el.tableValue] = el.value
            })
            return innerArray
        } else {
            innerArray = { "transaction": {}, "master": {} };
            innerArray.transaction.column = configArray.transaction.value;
            innerArray.master.column = configArray.master.value;
            return innerArray;
        }
    }

    prepareMergeArray(data){
        var operation_array = this.props.stepData.state.operation;
        var final_array = {};
        var conditions = null;
        var column_to_consider = {};
        var merge = {};
        merge.transaction = [];
        merge.master = [];
        let that = this;
        for (let index = 0; index < data.length; index++) {
            let master_table_name = data[index]["master"] === null ? data[index]["transaction"][index]['tableValue'] : null;
            let transaction_table_name = null;
            if (data[index]["master"] !== null) {
                master_table_name = data[index]["master"]['tableValue'];
                transaction_table_name = [];
                conditions === null ? conditions = {} : null;
                let checkMaster = (conditions[master_table_name] !== undefined && conditions[master_table_name] !== null) ? true : false;
                if(!checkMaster){
                    conditions[master_table_name] = [];
                }
            }
            if (this.props.stepData.state.final_transaction_table.length === 0 || data[index]["master"] === null) {
                transaction_table_name = data[index]["transaction"][index]['tableValue'];
                conditions === null ? conditions = [] : null;
                if (data[index]["master"] === null) {
                    if (merge.transaction.indexOf(transaction_table_name) === -1) {
                        data[index]["transaction"].map( el => {
                            merge.transaction.push(el.tableValue);
                        })
                    }
                } else {
                    if (merge.transaction.indexOf(transaction_table_name) == -1) {
                        merge.transaction.push(transaction_table_name);
                    }
                }
            } else {
                merge.transaction = transaction_table_name;
            }
            if (data[index]["master"] !== null) {
                if (merge.master.indexOf(master_table_name) == -1) {
                    merge.master.push(master_table_name);
                }
            }
            let checkColumnsConsider = (column_to_consider[master_table_name] !== undefined && conditions[master_table_name] !== null) ? true : false;
            if (!checkColumnsConsider){
                if (data[index]["master"] === null) {
                    if (Object.keys(column_to_consider).indexOf(master_table_name) === -1) {
                        data[index]["transaction"].map( el => {
                            column_to_consider[el.tableValue] = that.getColumnsToConsider(el.tableValue, index);    
                        })
                    }
                } else {
                    column_to_consider[master_table_name] = that.getColumnsToConsider(master_table_name, index);
                }
            }
            merge.column_to_consider = column_to_consider;
            final_array = that.getSelectedTableKeys(data[index], master_table_name);
            data[index]["master"] === null? conditions.push(final_array) : conditions[master_table_name].push(final_array);
        }
        merge.condition = conditions;
        operation_array.merge = merge;
        return operation_array;
    }

    backAction() {
        this.props.stepData.handleBackTrack(this);
    }
    nextAction() {
        if(this.state.joinData.length == 0){
            alert("Please add keys to complete this step!")
        } else {
            let result = this.prepareMergeArray(this.state.joinData);
            this.props.stepData.handleMergedTable(result);
            this.props.stepData.handleSteps(this);
        }
    }


    render() {
  
        let transaction_columns = null;
        let transaction_note = null;
        let master_columns = [];
        var displayCardBody = null;
        let master_array, transaction_array = {};
        
        if (this.props.stepData.state.selectedTable.transaction.length > 0 && this.props.stepData.state.selectedTable.master.length === 0 ) {
            let transactionTables = this.props.stepData.state.selectedTable.transaction;
            displayCardBody = transactionTables.map((el, index) => {
                let tables_array = {
                    "class": `tt_${index}`,
                    "id": "transaction_table",
                    "placeholder": "Select transaction tables",
                    "size": 5,
                    "dropdownData": [el],
                    "subtext": true,
                    "value": [el],
                    "valueFlag": false
                };
                let columns_array = {
                    "class": "tc-1",
                    "id": "transaction_table_columns",
                    "placeholder": "Select transaction columns",
                    "size": 5,
                    "dropdownData": el.columnConfig,
                    "subtext": true,
                    "value": [],
                    "valueFlag": false
                };

                return <div className="d-flex flex-row justify-content-start">
                    <div className="align-items-center mg-b-10 mg-r-10">
                        <label className="" htmlFor="transaction">Select a Transaction Table</label>
                        <MergeDropdownComponent type="transaction" dropdownConfig={tables_array} onChange={this.handleTableChange} />
                    </div>
                    <div className="align-items-center mg-b-10 mg-r-10">
                        <label className="" htmlFor="transaction">Select a Transaction Table Column</label>
                        <MergeDropdownComponent type="transaction" dropdownConfig={columns_array} onChange={this.handleTableChange} />
                    </div>
                </div>
            })
        } else {
            if (this.props.stepData.state.final_transaction_table.length == 0){
                transaction_columns = this.getFilteredTableColumns(this.props.stepData.state.selectedTable.transaction);
            } else {
                transaction_columns = this.props.stepData.state.final_transaction_table;
                transaction_note = (<span className="tx-medium mg-b-10">Note: Intermediate Transaction Table is the result of the Append Rows step</span>)
            }
            if (this.props.stepData.state.selectedTable.master.length !== 0) {
                master_columns = this.getFilteredTableColumns(this.props.stepData.state.selectedTable.master);
            }
            transaction_array = {
                "class": "my-1",
                "id": "transaction_table",
                "placeholder": "Select transaction columns",
                "size": 5,
                "dropdownData": transaction_columns,
                "subtext": true,
                "value": [],
                "valueFlag": false
    
            };
    
            master_array = {
                "class": "my-1",
                "id": "master_table",
                "placeholder": "Select master columns",
                "size": 5,
                "dropdownData": master_columns,
                "subtext": true,
                "value": [],
                "valueFlag": false
    
            };
        }
        
        let backButton = { "name": "Back", "event":this.backAction};
        return (
            <>
                <div className="card">
                    <div className="card-header d-flex flex-row justify-content-between">
                        <ButtonComponent buttonData={backButton} />
                        <button className="btn btn-primary btn-sm text-white" onClick={this.nextAction}>Next</button>
                    </div>
                    <div className="card-body">
                        {this.props.stepData.state.selectedTable.transaction.length > 0 && this.props.stepData.state.selectedTable.master.length === 0
                            ? displayCardBody
                            : <div className="d-flex flex-column justify-content-start">
                                {transaction_note}
                                <div>
                                    <div className="mg-b-10">
                                        <label className="" htmlFor="transaction">Select transaction columns</label>
                                        <MergeDropdownComponent type="transaction" dropdownConfig={transaction_array} onChange={this.handleTableChange} />
                                    </div>
                                    <div className="mg-b-10">
                                        <label className="" htmlFor="transaction">Select master columns</label>
                                        <MergeDropdownComponent type="master" dropdownConfig={master_array} onChange={this.handleTableChange} />
                                    </div>
                                </div>
                            </div>}
                        <div>
                            <button className="btn btn-sm btn-primary" onClick={this.submitTables}>Add Keys</button>
                        </div>
                        <div className="mt-2">
                            <span className="tx-spacing-1 mb-1">Mapping of Keys</span>
                            <TagsComponent placeholder={""} tags={this.props.stepData.state.joinData} suggestions={[]} controlState={this.getStateFromChild} />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.admin.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(StepFour);
// export default DataMerge;

